import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useActions } from 'app/hooks/useActions';
import { usePage } from 'modules/page/pageSelector';
import { usePostsCreateNew } from 'app/modules/posts/hooks/usePostsCreateNew';
import routes, { modalRoutes } from 'constants/routes';
import { ChecklistTaskHookResult } from 'app/modules/onboardingChecklist/types';

export const useConnectProfilesTask = (): ChecklistTaskHookResult => {
  const { t } = useTranslation();
  const { profileActions } = useActions('onboarding-checklist');
  const { pages } = usePage();
  const navigate = useNavigate();
  const location = useLocation();
  const { isInPostsModule } = usePostsCreateNew();

  const handleConnectProfiles = () => {
    if (isInPostsModule() || location.pathname.startsWith(routes.INSIGHTS)) {
      profileActions.add.perform?.();
    } else {
      navigate({
        pathname: routes.POSTS_CALENDAR,
        hash: modalRoutes.NEW_PROFILE,
      });
    }
  };

  return {
    task: {
      id: 'connect-profiles',
      title: t('onboardingChecklist.tasks.connectProfiles.title'),
      description: t('onboardingChecklist.tasks.connectProfiles.description'),
      ctaLabel: t('onboardingChecklist.tasks.connectProfiles.cta'),
      isDone: pages.some((page) => !page.isDemo && page.isConnected),
      perform: handleConnectProfiles,
    },
  };
};
